import * as React from "react";
import SentryService from "./sentry";
class ErrorBoundary extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.SentryService = new SentryService({ dsn: this.props.dsn });
        this.captureException = (err) => {
            this.SentryService.logError(err);
            return false;
        };
        this.captureDidCatchException = (error, errorInfo) => {
            this.SentryService.withScopeAdded(error, errorInfo);
        };
    }
    componentDidMount() {
        window.addEventListener("unhandledrejection", this.captureException);
        window.addEventListener("error", this.captureException);
    }
    componentWillUnmount() {
        window.removeEventListener("unhandledrejection", this.captureException);
        window.removeEventListener("error", this.captureException);
    }
    componentDidCatch(error, errorInfo) {
        this.captureDidCatchException(error, errorInfo);
    }
    render() {
        return React.createElement(React.Fragment, null, this.props.children);
    }
}
export default ErrorBoundary;
